<template>
  <div class="page-contact">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">My Personal Info</h1>
    <div v-if="loading">{{ loadingMessage }}<b-icon icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon></div>
    <div v-else-if="saved">
      Successfully saved your info! <a href="/">Back to My Dashboard</a>
    </div>
    <div v-else>
      <b-form @submit="onSubmit" @reset="onReset" v-if="show && !saving">

        <b-card bg-variant="light" class="mb-3" header="Basic Info">
          <b-form-group
            label-cols-sm="3"
            label="OHI ID:"
            label-align-sm="right"
          >
            <b-form-input disabled v-model="form.ARVC_Contact_ID__c" required></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Login Email:"
            label-align-sm="right"
          >
            <b-form-input disabled v-model="form.Email" required></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="First Name:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.FirstName" required></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Last Name:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.LastName" required></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Title:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.Title" required></b-form-input>
          </b-form-group>
        </b-card>

        <b-card bg-variant="light" class="mb-3" header="Contact Preferences">
          <b-form-group
            label-cols-sm="3"
            label="Work Email:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.OrderApi__Work_Email__c"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Personal Email:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.OrderApi__Personal_Email__c"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Preferred Contact Email:"
            label-align-sm="right"
          >
            <b-form-radio-group
                class="pt-2 pb-4"
                v-model="form.OrderApi__Preferred_Email_Type__c"
                :options="['Work', 'Personal']"
              ></b-form-radio-group>
          </b-form-group>
                    <b-form-group
            label-cols-sm="3"
            label="Work Phone:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.OrderApi__Work_Phone__c"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Mobile Phone:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.Phone"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Preferred Contact Phone:"
            label-align-sm="right"
          >
            <b-form-radio-group
                class="pt-2 pb-4"
                v-model="form.OrderApi__Preferred_Phone_Type__c"
                :options="['Work', 'Mobile']"
              ></b-form-radio-group>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Opt-in:"
            label-align-sm="right"
          >
            <b-form-checkbox v-model="form.FS_Mailing_Opt_in__c"
                             value="Yes" unchecked-value="No"
                             style="position: relative; top: 8px;">
              I approve of ARVC giving my member mailing address to Supplier Council Members
            </b-form-checkbox>
          </b-form-group>
        </b-card>

        <b-card bg-variant="light" class="mb-3" header="Mailing Address">
            <b-form-group
              label-cols-sm="3"
              label="Street Address:"
              label-align-sm="right"
            >
              <b-form-input v-model="form.MailingStreet"></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="City:"
              label-align-sm="right"
            >
              <b-form-input id="nested-city" v-model="form.MailingCity"></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="State / Province:"
              label-align-sm="right"
            >
              <b-form-input id="nested-state" v-model="form.MailingState"></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Zip / Postal:"
              label-align-sm="right"
            >
              <b-form-input id="nested-state"
                v-model="form.MailingPostalCode"></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Country:"
              label-align-sm="right" class="mb-0"
            >
              <b-form-radio-group
                class="pt-2 pb-4"
                v-model="form.MailingCountry"
                :options="['United States', 'Canada']"
              ></b-form-radio-group>
            </b-form-group>
        </b-card>

        <div class="text-right pb-5">
          <b-button type="submit" variant="primary" class="fr">Save Personal Info</b-button>
        </div>
      </b-form>
      <b-card class="mt-3 dev-only" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import Multiselect from 'vue-multiselect';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Listing',
  components: {
    // Multiselect,
  },
  data() {
    return {
      loading: true,
      saving: false,
      saved: false,
      loadingMessage: 'Loading... Please Wait...',
      slug: null,
      form: {},
      picklists: {},
      show: true,
    };
  },
  methods: {
    genForm() {
      const form = JSON.parse(JSON.stringify(this.form));
      return form;
    },
    async onSubmit(evt) {
      this.saving = true;
      evt.preventDefault();
      window.scrollTo(0, 0);
      const payload = this.genForm();
      console.log({ payload });
      try {
        const saveResponse = await axios.post(`${server}/api/contact`, payload);
        this.saved = true;
        console.log({ saveResponse });
      } catch (saveError) {
        console.log('SHIT');
      }
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.Account_Org_Address__c = null;

      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawContact = await axios.get(`${server}/api/contact`);
        if (rawContact.data.redirect) {
          window.location.href = rawContact.data.redirect;
          return;
        }
        console.log('Loading contact', rawContact);
        this.picklists = rawContact.data.picklists;
        this.form = rawContact.data;
        this.loading = false;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      } catch (err) {
        console.log({ getContactError: err });
        this.loadingMessage = 'There was an issue pulling your personal info. Please let us know so we can take a look!';
      }
    });
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
  .view-listing-link {
    display: block;
    text-align: right;
    position: relative;
    top: 36px;
    right: 24px;
    z-index: 2;
  }
</style>
